import React, { ReactNode, useState } from 'react'
import uuid from 'uuid'

import { Grid } from '@mindfulchefuk/design-system'

export const SearchGrid = ({ children }: { children?: ReactNode }) => {
  const [identifier] = useState(uuid.v4())

  const columns = () => {
    if (!Array.isArray(children)) return children

    return children.map((child, idx) => {
      const key = `search-grid-item-${identifier}-${idx}`
      return <div key={key}>{child}</div>
    })
  }

  return (
    <Grid
      columnGap={24}
      rowGap={[20, 24]}
      templateColumns={{ base: '1fr', sm: '1fr 1fr', md: '1fr 1fr 1fr' }}
      align="stretch"
    >
      {children && columns()}
    </Grid>
  )
}
